import React from 'react'
import "../../Css/Gpu.css";
import Nav from '../../Utils/Nav';
import banner from '../../Assets/background2.JPG'
import Footer from '../../Utils/Footer';




const Specifications = () => {

    const gpuSpecs = {systemMemory:"1TiB",ramSlot : "16 X [64GiB DIMM DDR4 Synchronous Registered (Buffered) 3200 MHz (0.3 ns)]",
        cache:"2 X [4MiB L1, 32MiB L2, 256MiB L3]",
        storage1:"SAMSUNG NVMe 1.8T / OS",
        storage2:"SAMSUNG NVMe 14T /raid0",
        networkInterface:["2 X LAN","BMC Network"],
        cpu:["AMD EPYC 7742 64-Core Processor",
            "Virtualization: AMD-V",
            "CPU(s):256",
            "Architecture: x86_64",
            "CPU op-mode(s):32-bit, 64-bit",
            "CPU family: 23",
            "Model: 49",
            "Thread(s) per core:2",
            "Core(s) per socket: 64",
            "Socket(s): 2",
            "CPU max MHz: 2250.0000",
            "CPU min MHz: 1500.0000"],
        biosInfo:["Vendor: American Megatrends Inc.",
            "Version: 1.18",
            "Release Date: 10/25/2022",
            "Address: 0xF0000",
            "Runtime Size: 64 kB",
            "ROM Size: 16 MB","SMBIOS 3.2.0 present",

        ],
        gpu:["GPU Count: 15","Product Name : NVIDIA A100-SXM4-40GB","Product Brand : NVIDIA",
            "Product Architecture : Ampere","VBIOS Version : 92.00.45.00.03",
            "Total Memory : 40960 MiB","GSP Firmware Version : 550.90.07","GPU T.Limit Temp : N/A",
            "GPU Shutdown Temp : 92 C","GPU Slowdown Temp : 89 C","GPU Max Operating Temp : 85 C",
            "GPU Target Temperature : N/A","Memory Current Temp : 31 C","Memory Max Operating Temp : 95 C",
            "Power Draw : 61.02 W","Current Power Limit : 400.00 W","Requested Power Limit : 400.00 W",
            "Default Power Limit : 400.00 W","Min Power Limit : 100.00 W",
            "Max Power Limit : 400.00 W","Clocks","Graphics : 1095 MHz",
            "SM : 1095 MHz","Memory : 1215 MHz",
            "Video : 1005 MHz",
        ]

    }

  return (
    <>
    <Nav/>
    <div className='main-container'>
    <div className="banner">
                <img className="background" src={banner} alt="" />
            <h1 className="main-heading-title">GPU Servers Specifications</h1>
    
            </div>
   <div className="gpu-spec-container">
    <div className='gpu-head'>
        <table className='gpu-table'>
            <tbody>
            <tr>
                <td className='gpu-row-head'>GPUs Server Make & GPUs Model</td>
                <td>NVIDIA A100</td>
            </tr>
            <tr>
            <td className='gpu-row-head'>Node Count</td>
                <td>02</td>
                </tr>
                <tr>
                    <td className='gpu-row-head'>Hostname</td>
                    <td>him1, him2</td>
                </tr>
                </tbody>
        </table>
    </div>

      <div className="spec-section">
        <h2>System Memory</h2>
        <p>{gpuSpecs.systemMemory}</p>
      </div>

      <div className="spec-section">
        <h2>RAM Slots</h2>
        <p>{gpuSpecs.ramSlot}</p>
      </div>

      <div className="spec-section">
        <h2>Cache</h2>
        <p>{gpuSpecs.cache}</p>
      </div>

      <div className="spec-section">
        <h2>Storage</h2>
        <ul>
          <li>{gpuSpecs.storage1}</li>
          <li>{gpuSpecs.storage2}</li>
        </ul>
      </div>

      <div className="spec-section">
        <h2>Network Interfaces</h2>
        <ul>
          {gpuSpecs.networkInterface.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </div>

      <div className="spec-section">
        <h2>CPU Details</h2>
        <ul>
          {gpuSpecs.cpu.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </div>

      <div className="spec-section">
        <h2>BIOS Information</h2>
        <ul>
          {gpuSpecs.biosInfo.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </div>

      <div className="spec-section">
        <h2>GPU Details</h2>
        <ul>
          {gpuSpecs.gpu.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </div>
    </div>
    </div>
    <Footer/>
    </>
  )
}

export default Specifications
